import React, { useState, useEffect } from 'react';
import { useMutation, gql } from '@apollo/client';
import jsPDF from 'jspdf';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faShoppingCart}from '@fortawesome/free-solid-svg-icons';
import { faHouse}from '@fortawesome/free-solid-svg-icons';


const ACTUALIZAR_STOCK = gql`
  mutation editarProducto(
    $id: ID!
    $nuevoNombre: String
    $nuevaImagen: String
    $nuevoCodigo: String
    $nuevoStock: Int
    $nuevoPrecio: Decimal
  ) {
    editarProducto(
      _id: $id
      nombre: $nuevoNombre
      imagen: $nuevaImagen
      codigo: $nuevoCodigo
      stock: $nuevoStock
      precio: $nuevoPrecio
    ) {
      _id
      nombre
      precio
      stock
      codigo
      imagen
    }
  }
`;

const NUEVO_PEDIDO = gql`
  mutation crearPedido(
    $estado: String
    $fecha: String
    $nombreCliente: String
    $direccionCliente: String
    $whatsappCliente: String
    $notaPedido: String
    $productos: String
  ) {
    crearPedido(
      estado: $estado
      fecha: $fecha
      nombreCliente: $nombreCliente
      direccionCliente: $direccionCliente
      whatsappCliente: $whatsappCliente
      notaPedido: $notaPedido
      productos: $productos
    ) {
      _id
      estado
      fecha
      numeroPedido
      nombreCliente
      direccionCliente
      whatsappCliente
      notaPedido
      productos
    }
  }
`;

// Función para formatear la fecha a GMT-5
function formatFechaGMT5() {
  const fecha = new Date();
  const offset = 0; // GMT-5
  const localTime = new Date(fecha.getTime() + offset * 60 * 1000);
  const year = localTime.getFullYear();
  const month = (localTime.getMonth() + 1).toString().padStart(2, '0');
  const day = localTime.getDate().toString().padStart(2, '0');
  const hours = localTime.getHours().toString().padStart(2, '0');
  const minutes = localTime.getMinutes().toString().padStart(2, '0');

  return `${year}-${month}-${day}T${hours}:${minutes}`;
}

function FinalizarCompra(props) {
  const [estado, setEstado] = useState("esperando");
  const [fecha, setFecha] = useState(formatFechaGMT5());
  const [nombreCliente, setNombreCliente] = useState("");
  const [direccionCliente, setDireccionCliente] = useState("");
  const [whatsappCliente, setWhatsappCliente] = useState("");
  const [notaPedido, setNotaPedido] = useState("");
  const [productos, setProductos] = useState("");
  const [nuevoPedido] = useMutation(NUEVO_PEDIDO);
  const [carritoLocal, setCarritoLocal] = useState([]);

  useEffect(() => {
    const carritoGuardado = JSON.parse(localStorage.getItem('carrito')) || [];
    setCarritoLocal(carritoGuardado);
    setFecha(formatFechaGMT5());
  }, []);

  const [actualizarStock] = useMutation(ACTUALIZAR_STOCK);

  const handleCompraClick = async () => {
    for (const producto of carritoLocal) {
      const { _id, nombre, imagen, codigo, precio, stock, cantidad } = producto;

      await actualizarStock({
        variables: {
          id: _id,
          nuevoNombre: nombre,
          nuevaImagen: imagen,
          nuevoCodigo: codigo,
          nuevoPrecio: precio,
          nuevoStock: stock - cantidad,
        },
      });
    }

    // Limpiar el carrito
    localStorage.removeItem('carrito');
    setCarritoLocal([]);
  };

  // Generar mensaje de WhatsApp
  const generarMensajeWhatsapp = () => {
    let mensaje = `Hola ${nombreCliente}, gracias por tu compra.\n\nDetalles de compra:\n`;

    carritoLocal.forEach((producto) => {
      mensaje += `${producto.nombre} - Cantidad: ${producto.cantidad} - Precio: ${producto.precio}\n`;
    });

    mensaje += `\nTotal del pedido: ${carritoLocal.reduce((total, prod) => total + (prod.precio * prod.cantidad), 0)}\n`;
    mensaje += `\nDirección de entrega: ${direccionCliente}\n`;
    mensaje += `Nota: ${notaPedido}`;

    return encodeURIComponent(mensaje);
  };

  // Generar PDF con datos del cliente y productos
  const generarPDF = () => {
    const doc = new jsPDF();
    
    // Añadir datos del cliente
  
    doc.text(`Cliente: ${nombreCliente}`, 10, 20);
    doc.text(`Dirección: ${direccionCliente}`, 10, 30);
    doc.text(`WhatsApp: ${whatsappCliente}`, 10, 40);
    
    // Añadir detalles del pedido
    doc.text("Detalles de la compra", 10, 50);
    carritoLocal.forEach((producto, index) => {
      doc.text(`${producto.nombre} - Cantidad: ${producto.cantidad} - Precio: ${producto.precio}`, 10, 60 + (index * 10));
    });

    const total = carritoLocal.reduce((total, prod) => total + (prod.precio * prod.cantidad), 0);
    doc.text(`Total del pedido: ${total}`, 10, 70 + (carritoLocal.length * 10));

    doc.save('pedido.pdf');  // Guarda el PDF en el navegador
  };

  const pedidoSubmit = async (e) => {
    e.preventDefault();
    const carritoString = JSON.stringify(carritoLocal);

    // Crear pedido en la base de datos
    await nuevoPedido({
      variables: {
        estado,
        fecha,
        nombreCliente,
        direccionCliente,
        whatsappCliente,
        notaPedido,
        productos: carritoString,
      },
    });

    // Actualizar stock, generar PDF y abrir WhatsApp
    handleCompraClick();
    {/**generarPDF();

    // Redirigir a WhatsApp en una nueva ventana o reutilizar una existente
    const numeroWhatsApp = `57${whatsappCliente}`;
    const mensaje = generarMensajeWhatsapp();
    const enlaceWhatsApp = `https://web.whatsapp.com/send?phone=${numeroWhatsApp}&text=${mensaje}`;
    window.open(enlaceWhatsApp, 'whatsappWindow');*/}

    // Limpiar los campos del formulario
    setNombreCliente("");
    setFecha(formatFechaGMT5());
    setDireccionCliente("");
    setWhatsappCliente("");
    setNotaPedido("");
  };

  return (
    <div>
      {carritoLocal.length === 0 && (
        <div className="alert alert-success text-center" role="alert">
          <h4 className="alert-heading">Agrega productos al carrito</h4>
          <a className='btn-medicina btn' href="/">
        <FontAwesomeIcon icon={faHouse} />
      </a>
        </div>
      )}

      {carritoLocal.length > 0 && (
        <center>
         <div className="card  card-salida col-xs-12 col-xl-4 col-sm-6">
                    <div className="card-body">
        <form onSubmit={pedidoSubmit}>
          <input type="hidden" name="estado" value="esperando" />
          <input type="text" name="fecha" value={fecha} /> {/* Fecha con GMT-5 */}
          <h3>Nombres</h3>
          <input placeholder="nombre completo" value={nombreCliente} onChange={evt => setNombreCliente(evt.target.value)} />
         {/*} <h3>Direccion</h3>
          <input placeholder="ejemplo: calle 123 #01-01" value={direccionCliente} onChange={evt => setDireccionCliente(evt.target.value)} />
          <h3>Whatsapp (se usara para notificaciones del pedido)</h3>
          <input placeholder="ejemplo: 3010000000" value={whatsappCliente} onChange={evt => setWhatsappCliente(evt.target.value)} />
          <h3>Notas de pedido</h3>
          <input placeholder="ejemplo: informacion adicional del pedido" value={notaPedido} onChange={evt => setNotaPedido(evt.target.value)} />
          <input type="hidden" value={JSON.stringify(carritoLocal, null, 2)} />*/}
          <br />
          <br />
          <button className="btn btn-salida">Finalizar venta</button>
        </form>
        </div>
        </div>
        </center>
      )}

      {/*carritoLocal.length > 0 && (
        <ul>
          {carritoLocal.map((producto, index) => (
            <li key={index}>
              <img src={producto.imagen} width="50px" alt="" />
              {producto.nombre} - ${producto.precio} x {producto.cantidad}
            </li>
          ))}
        </ul>
      )*/}
    </div>
  );
}

export default FinalizarCompra;
